import React, { useState } from "react";
import Notiflix from "notiflix";

import {
  Row,
  Form,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Select,
  Button,
  Modal,
  Tooltip,
  InputNumber,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import styles from "../../../../assets/styles/styles";
import { labelConfig, staticConfig } from "../../systemAdmin.config";

const CurrencyForm = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    // isLoading,
    // setIsLoading,
    configureCurrencyTableSource,
    setConfigureCurrencyTableSource,
    paymentTypeOptions,
    assetAccountOptions,
    currencyCount,
    setCurrencyCount,
    currencyData,
    setFormData,
    formData,
    selectedbranchConfigValueCurrencyCode,
  } = props;
  // console.log(currencyData);

  const { Title } = Typography;

  // DECLARED VARIABLES FOR FORM
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleVaultCurrencyDelete = (record) => {
    const { id, currencyCode } = record;

    if (id === undefined || currencyCode === undefined) {
      console.warn("Invalid record", record);
      BOM.AlertMsg(
        cnt.WARNING,
        "Could not delete currency. Missing ID or Code."
      );
      return;
    }

    Notiflix.Confirm.show(
      "Please confirm action",
      "",
      "Yes",
      "No",

      function () {
        const newTableData = configureCurrencyTableSource.filter(
          (item) => item.id !== id
        );
        setConfigureCurrencyTableSource(newTableData);

        // ✅ Remove from formData.currencyForm by currencyCode
        setFormData((prev) => ({
          ...prev,
          currencyForm: prev.currencyForm.filter(
            (item) => item.currencyCode !== currencyCode
          ),
        }));
      },

      function () {
        // Cancelled
      }
    );
  };

  const columns = [
    {
      title: "Vault Currency",
      dataIndex: "currencyCode",
    },
    {
      title: "Maximum Vault Limit",
      dataIndex: "vaultMaxAmount",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        configureCurrencyTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleVaultCurrencyDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Currency Information
        </Title>
      </Divider>
      <CurrencyModal
        isModalOpen={isModalOpen}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setIsModalOpen={setIsModalOpen}
        paymentTypeOptions={paymentTypeOptions}
        assetAccountOptions={assetAccountOptions}
        setConfigureCurrencyTableSource={setConfigureCurrencyTableSource}
        configureCurrencyTableSource={configureCurrencyTableSource}
        currencyCount={currencyCount}
        setCurrencyCount={setCurrencyCount}
        currencyData={currencyData}
        setFormData={setFormData}
        formData={formData}
        selectedbranchConfigValueCurrencyCode={
          selectedbranchConfigValueCurrencyCode
        }
      />

      {configureCurrencyTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {configureCurrencyTableSource.length > 1
                ? "Added Currencies"
                : "Added Currency"}
            </Title>
          </Divider>
          <Table
            rowKey="id"
            columns={columns}
            dataSource={configureCurrencyTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
        </>
      )}
    </Form>
  );
};
export default CurrencyForm;

const CurrencyModal = (props) => {
  const {
    isLoading,
    setIsLoading,
    setConfigureCurrencyTableSource,
    configureCurrencyTableSource,
    isModalOpen,
    setIsModalOpen,
    currencyCount,
    setCurrencyCount,
    currencyData,
    setFormData,
    formData,
    selectedbranchConfigValueCurrencyCode,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCurrencyFormSave = (formValues) => {
    const newCurrencyInfo = {
      key: currencyCount,
      id: currencyCount,
      currencyCode: formValues.currencyCode,
      vaultMaxAmount: formValues.vaultMaxAmount,
    };

    setCurrencyCount(currencyCount + 1);

    const foundLimits = configureCurrencyTableSource.find(
      (item) => item.currencyCode === newCurrencyInfo?.currencyCode
    );
    if (foundLimits) {
      BOM.AlertMsg(cnt.WARNING, "No Duplicate Limit Allowed!");
      return;
    }

    // ✅ Update table data
    setConfigureCurrencyTableSource([
      ...configureCurrencyTableSource,
      newCurrencyInfo,
    ]);

    // ✅ Update formData.currencyForm
    setFormData((prev) => ({
      ...prev,
      currencyForm: [
        ...(prev?.currencyForm || []),
        {
          currencyCode: newCurrencyInfo.currencyCode,
          vaultMaxAmount: newCurrencyInfo.vaultMaxAmount,
        },
      ],
    }));

    // ✅ Clear the form
    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
      >
        <PlusCircleOutlined />
        &nbsp; {"Add"}
      </Button>

      <Modal
        title="Vault Currency Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleCurrencyFormSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="currencyCode"
                label={labelConfig.vaultCurrency}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.vaultCurrency),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.currency,
                    "select"
                  )}
                  options={selectedbranchConfigValueCurrencyCode}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="vaultMaxAmount"
                label={labelConfig.maximumVaultLimit}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.maximumVaultLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.maximumVaultLimit
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
